// services
import { BaseApiResponse, BaseSearchRequest, ResultBaseProps } from 'modules/common';
import AxiosInstanceCreator from 'services/api';
import {
  ILastProtection,
  IProtection,
  ReqCreateProtection,
  ResLastProtections,
  ResProtections
} from '../model/protection.model';
import { AxiosInstance } from 'axios';

const protectionInstance = new AxiosInstanceCreator().create();

export const protectionApi = {
  /**
   * 작업자 보호구 등록
   * @param {*} data
   * @returns
   */
  async createProtection(data: ReqCreateProtection): Promise<ResultBaseProps> {
    return protectionInstance.post(`/protection`, data).then((res) => res.data);
  },

  /**
   * 작업자 보호구 조회
   * @param {workerId} id
   * @returns
   */
  async getProtection(workerId: string): Promise<ResProtections> {
    return protectionInstance.get(`/protection/${workerId}`).then((res) => res.data);
  },

  /**
   * 작업자 최신 보호구 조회
   * @param {workerId} id
   * @returns
   */
  async getProtectionLast(workerId: string): Promise<ResLastProtections> {
    return protectionInstance.get(`/protection/last/${workerId}`).then((res) => res.data);
  },

  /**
   * 작업자 보호구 삭제
   * @param {workerId} id
   * @returns
   */
  async deleteProtection(workerId: string): Promise<ResultBaseProps> {
    return await protectionInstance.delete(`/protection/${workerId}`).then((res) => res.data);
  }
};

export class ProtectionAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** 작업자 보호구 지급 이력 전체 조회 API */
  async getProtections(
    userId: string,
    params: BaseSearchRequest
  ): Promise<BaseApiResponse<unknown, IProtection>> {
    return this.Axios.get<BaseApiResponse<unknown, IProtection>>(`/protection/${userId}`, {
      params
    }).then((res) => res.data);
  }

  /** 작업자 보호구 별 마지막 지급 이력 조회 API */
  async getLastProtections(userId: string): Promise<BaseApiResponse<unknown, ILastProtection>> {
    return this.Axios.get<BaseApiResponse<unknown, ILastProtection>>(
      `/protection/last/${userId}`
    ).then((res) => res.data);
  }

  /** 작업자 보호구 지급 회수 API */
  async deleteProtection(userId: string): Promise<BaseApiResponse> {
    return this.Axios.delete<BaseApiResponse>(`/protection/${userId}`).then((res) => res.data);
  }

  /** 작업자 보호구 지급 API */
  async createProtection(data: ReqCreateProtection): Promise<BaseApiResponse> {
    return this.Axios.post<BaseApiResponse>(`/protection`, data).then((res) => res.data);
  }
}
